export const FacilityConst = {
  ALL_FACILITY_OPTION: { label: 'All Facilities', value: '0', isCoreMeasures: true, hasServiceCodes: true, isOutcomes: true, pixDataEntry: '1', isUHS: false },
};
